// Aviso "sem conexão" (pedido 2026-10-27: um PC do escritório ficou 4,5 min
// sem alcançar o servidor no meio do "Salvar"; "nunca pode cair o sistema").
// Não bloqueia nada: gravações seguem tentando sozinhas (fetch-retry.ts) e
// terminam quando a conexão volta; o aviso some no mesmo instante.
import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";
import { NETWORK_LOST_EVENT, NETWORK_RESTORED_EVENT } from "@/lib/api/fetch-retry";

// Quedas de 1-2 s (deploy, troca de rede) não chegam a mostrar nada.
const SHOW_AFTER_MS = 4000;

export function ConnectionLostBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | null = null;
    const onLost = () => {
      if (timer) return;
      timer = setTimeout(() => setVisible(true), SHOW_AFTER_MS);
    };
    const onRestored = () => {
      if (timer) clearTimeout(timer);
      timer = null;
      setVisible(false);
    };
    window.addEventListener(NETWORK_LOST_EVENT, onLost);
    window.addEventListener(NETWORK_RESTORED_EVENT, onRestored);
    return () => {
      if (timer) clearTimeout(timer);
      window.removeEventListener(NETWORK_LOST_EVENT, onLost);
      window.removeEventListener(NETWORK_RESTORED_EVENT, onRestored);
    };
  }, []);

  if (!visible) return null;

  return (
    <div
      role="status"
      className="pointer-events-none fixed inset-x-3 top-3 z-[2000] mx-auto flex max-w-md items-center gap-3 rounded-2xl border border-amber-300 bg-amber-50 px-4 py-3 shadow-2xl animate-in fade-in slide-in-from-top-2 dark:border-amber-800 dark:bg-amber-950"
    >
      <WifiOff className="h-5 w-5 shrink-0 text-amber-600 dark:text-amber-400" />
      <div className="min-w-0 text-xs text-amber-900 dark:text-amber-100">
        <p className="text-sm font-semibold">Sem conexão com o servidor</p>
        <p className="mt-0.5">
          Tentando reconectar… Não feche nem atualize a página: o que você salvou será gravado
          assim que a conexão voltar.
        </p>
      </div>
    </div>
  );
}
